import React, { useState } from 'react';
import { useRouter } from '@/hooks';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import { Stack, Typography } from '@mui/material';
import { West as BackIcon } from '@mui/icons-material';
import { InviteUsersModal } from './Dialogs/InviteUsersModal';
import { AddGroupDialog } from './Dialogs/AddGroupDialog';
import { AddTeamDialog } from './Dialogs/AddTeamDialog';
import { UserManagementTabs } from '@/types';
import { abyssColors } from '@/theme/colors';
import { SmallButton } from './styles';

type Props = {
  currentTab: UserManagementTabs;
};

export const Header = ({ currentTab }: Props) => {
  const [createGroupModal, setCreateGroupModal] = useState(false);
  const [createTeamModal, setCreateTeamModal] = useState(false);
  const [invitationModalOpen, setInvitationModalOpen] = useState(false);
  const handleOpen = () => setInvitationModalOpen(true);
  const handleClose = () => setInvitationModalOpen(false);
  const Router = useRouter();

  const handleToggleCreateGroupModal = () => setCreateGroupModal(!createGroupModal);
  const handleToggleCreateTeamModal = () => setCreateTeamModal(!createTeamModal);

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      padding="32px"
      paddingRight="40px"
    >
      <Stack direction="row" alignItems="center" spacing={4}>
        <BackIcon
          onClick={() => Router.back()}
          style={{ cursor: 'pointer', color: abyssColors.primary[500] }}
        />
        <Typography
          textTransform="uppercase"
          fontSize="2.4rem"
          fontWeight={700}
          color={abyssColors.primary[500]}
        >
          User Management
        </Typography>
      </Stack>
      <Stack direction="row" alignItems="center" gap={2}>
        <SmallButton
          startIcon={<GroupAddIcon />}
          onClick={handleOpen}
          contained
          data-testid="invite-user-btn"
        >
          Invite User
        </SmallButton>
        {currentTab === UserManagementTabs.GROUPS && (
          <SmallButton onClick={handleToggleCreateGroupModal} data-testid="create-group-btn">
            Create Group
          </SmallButton>
        )}
        {currentTab === UserManagementTabs.TEAMS && (
          <SmallButton onClick={handleToggleCreateTeamModal} data-testid="create-team-btn">
            Create Team
          </SmallButton>
        )}
        <AddGroupDialog open={createGroupModal} handleToggle={handleToggleCreateGroupModal} />
        <AddTeamDialog open={createTeamModal} handleToggle={handleToggleCreateTeamModal} />
      </Stack>
      <InviteUsersModal open={invitationModalOpen} handleClose={handleClose} />
    </Stack>
  );
};
